/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';

import {
  CalendarIcon,
  ChevronDownIcon,
  ChevronUpIcon,
} from '@heroicons/react/solid';

export interface IPeriodOverviewWidgetProps {
  category: string;
  title: string;
  period?: string;
  percentage?: number;
  ChartComponent?: any;
}

export const PeriodOverviewWidget = ({
  category,
  title,
  period,
  percentage,
  ChartComponent,
}: IPeriodOverviewWidgetProps) => {
  const PercentageIcon = percentage < 0 ? ChevronDownIcon : ChevronUpIcon;
  const percentageColor = percentage < 0 ? 'text-danger' : 'text-success';
  const _renderChartComponentIf = () => {
    if (ChartComponent) {
      return (
        <Col xs={12} xxl={6} className="px-xxl-0 mb-3 mb-xxl-0">
          <ChartComponent />
        </Col>
      );
    }
  };

  const _renderCategoryIf = () => {
    if (category) {
      return <h2 className="fs-5 fw-normal mb-1">{category}</h2>;
    }
  };

  const _renderTitleIf = () => {
    if (title) {
      return <h3 className="fw-extrabold mb-1">{title}</h3>;
    }
  };

  const _renderPeriodIf = () => {
    if (period) {
      return (
        <small className="d-flex align-items-center">
          <CalendarIcon className="icon icon-xxs text-gray-400 me-1" />
          {period}
        </small>
      );
    }
  };

  const _renderPercentageIf = () => {
    if (percentage) {
      return (
        <div className="small d-flex mt-1">
          <PercentageIcon className={`icon icon-xs ${percentageColor}`} />
          <span className={`${percentageColor} fw-bolder me-1`}>
            {Math.abs(percentage)}%
          </span>{' '}
          Since last month
        </div>
      );
    }
  };

  if (title) {
    return (
      <>
        <Card border="0" className="shadow">
          <Card.Body>
            <Row className="d-block d-xxl-flex align-items-center">
              {_renderChartComponentIf()}
              <Col xs={12} xxl={6} className="ps-xxl-4 pe-xxl-0">
                {_renderCategoryIf()}
                {_renderTitleIf()}
                {_renderPeriodIf()}
                {_renderPercentageIf()}
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </>
    );
  }
};

PeriodOverviewWidget.defaultProps = {};
